@for (category of data; track category.id) {
  <dcr-section
    #section
    data-cy="expansion-panel-toc-result-list-item-groups"
    [headline]="category.label"
    heading-level="h5"
    standout
    [open]="!!activePanels[category.id]"
    (opened)="addActivePanel(category.id)"
    (closed)="removeActivePanel(category.id)"
  >
    <span class="on-surface-variant label-medium" slot="trailing-image" data-cy="toc-result-product-type-count">
      ({{ category.contentCount }})
    </span>
    <div class="toc-result-list-item-groups__group-content">
      @switch (category.type) {
        <!-- GRID TYPE -->
        @case ('grid') {
          <ng-container class="cluster gap-m">
            <campus-toc-result-grid-item-groups
              [category]="category"
              [trackById]="trackById"
              [trackByEduContentId]="trackByEduContentId"
              (selectionChange)="onEduContentSelectionChange($event)"
            ></campus-toc-result-grid-item-groups>
          </ng-container>
        }
        <!-- DISPLAY TYPE -->
        @case ('display') {
          <ng-container class="cluster gap-m">
            <campus-toc-result-display-item
              [category]="category"
              [trackById]="trackById"
              [trackByEduContentId]="trackByEduContentId"
            ></campus-toc-result-display-item>
          </ng-container>
        }
        <!-- DEFAULT TYPE -->
        @default {
          <div class="flex flex-column gap-xl p-be-m">
            @for (subCategory of category.subCategories; track subCategory.id; let last = $last) {
              <div
                class="flex flex-column gap-s"
                [ngClass]="
                  category.showSubCategories ? ['flex', 'flex-column', 'gap-s'] : ['auto-grid', 'auto-grid-fill', 'auto-grid-min-xs']
                "
              >
                @if (category.showSubCategories && subCategory.name; as subCategoryName) {
                  <div class="title-medium">
                    {{ subCategoryName }}
                  </div>
                }
                <div [ngClass]="viewType === ViewListAsEnum.LIST ? '' : 'auto-grid auto-grid-fill auto-grid-min-xs '">
                  @for (eduContentSearch of subCategory.contents; track eduContentSearch.eduContent.id; let last = $last) {
                    <campus-edu-content-result-loader
                      #eduContentPendingResult
                      [eduContentId]="eduContentSearch.eduContent.id"
                      class="w-full"
                    >
                      <campus-toc-result-list-item
                        [type]="viewType === ViewListAsEnum.LIST ? 'list' : 'card'"
                        class="w-full"
                        [ngClass]="{
                          '[ filter blur-2xs grayscale-100 pointer-event-none ]': eduContentPendingResult.eduContentResultPending$ | async,
                        }"
                        [data]="eduContentSearch"
                        [selected]="eduContentSearch.checked"
                        (selectionChange)="onEduContentSelectionChange($event)"
                        [isFavorite]="!!favoriteEduContents[eduContentSearch.eduContent.id]"
                        (toggleFavorite)="onToggleFavorite($event)"
                        [inBasket]="eduContentSearch.inBasket"
                        (clickLevelAttempts)="onClickLevelAttempts($event)"
                      ></campus-toc-result-list-item>
                      @if (viewType === ViewListAsEnum.LIST && !last) {
                        <dcr-divider></dcr-divider>
                      }
                    </campus-edu-content-result-loader>
                  }
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  </dcr-section>
}
